/* global WebSocket */
import { eventBus, lastJobUpdate, refreshCredits } from './state.js'

let socket = null
let reconnectTimeout = null

export const connectEvents = () => {
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const wsUrl = `${protocol}//${window.location.host}/api/events`

  socket = new WebSocket(wsUrl)

  socket.onopen = () => {
    console.log('Connected to event stream')
    if (reconnectTimeout) clearTimeout(reconnectTimeout)
  }

  socket.onmessage = (event) => {
    console.log('WS: Raw message received:', event.data)
    try {
      const data = JSON.parse(event.data)
      console.log('WS: Parsed data:', data)
      if (data.type === 'JOB_UPDATE') {
        console.log('WS: Emitting job_update via lastJobUpdate and eventBus')
        lastJobUpdate(data)
        eventBus.emit('job_update', data)
      } else if (data.type === 'CREDITS_UPDATED') {
        console.log('WS: Credits updated, refreshing...')
        refreshCredits()
      }
    } catch (err) {
      console.error('WS: Failed to parse event data:', err)
    }
  }

  socket.onclose = () => {
    console.log('Event stream closed, reconnecting...')
    reconnectTimeout = setTimeout(connectEvents, 3000)
  }

  socket.onerror = (err) => {
    console.error('Event stream error:', err)
    socket.close()
  }
}
